document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  //setTimeout

  ScrollTrigger.matchMedia({
    // メディアのサイズに関係なく、すべてに適用する
    all: function () {
      const custom_anime = gsap.timeline({
        scrollTrigger: {
          trigger: ".thumListScroll",
          start: "top bottom",
          end: "bottom top",
          scrub: "true",
        },
        
      });

      custom_anime.to(".cleanSec", {
        keyframes: [{ duration: 1, top: "50%",visibility: "visible" }],
      });

      custom_anime.to(
        ".item07",
        {
          keyframes: [{ duration: 1, width: "100%" }],
        },
        ">"
      );
      custom_anime.to(
        ".item06",
        {
          keyframes: [{ duration: 1, width: "0%" }],
        },
        "<"
      );
      custom_anime.to(
        ".item08",
        {
          keyframes: [{ duration: 1, width: "0%" }],
        },
        "<"
      );

      custom_anime.to(
        ".cleanSec",
        {
          keyframes: [{ duration: 1, opacity: "1" }],
        },
        ">"
      );
      custom_anime.to(
        ".cleanSec",
        {
          keyframes: [{ duration: 1, top: "-100%" }],
        },
        ">"
      );

      gsap.to(".bgSection01", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section02",
          start: "top 50%",
          end: "top 40%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".bgSection03", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section02",
          start: "top 50%",
          end: "top 40%",
          scrub: "true",
        },
        opacity: "3",
      });
      gsap.to(".bgSection03", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section03",
          start: "top 0%",
          end: "top -3%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".bgSection04", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section03",
          start: "top 0%",
          end: "top -3%",
          scrub: "true",
        },
        opacity: "1",
      });
    },
    //end matchMedia
  });
});

// document.addEventListener("DOMContentLoaded", function () {
//   gsap.registerPlugin(ScrollTrigger);
//   //setTimeout

//   ScrollTrigger.matchMedia({
//     all: function () {
//       const historySections = [
//         { trigger: ".his02", opacity: ".his01 .overlay" },
//         { trigger: ".his03", opacity: ".his02 .overlay" },
//         { trigger: ".his04", opacity: ".his03 .overlay" },
//         { trigger: ".his05", opacity: ".his04 .overlay" },
//         { trigger: ".his06", opacity: ".his05 .overlay" },
//         { trigger: ".his07", opacity: ".his06 .overlay" },
//         { trigger: ".his08", opacity: ".his07 .overlay" },
//         { trigger: ".his09", opacity: ".his08 .overlay" },
//         { trigger: ".his010", opacity: ".his09 .overlay" },
//         { trigger: ".his011", opacity: ".his10 .overlay" },
//       ];

//       historySections.forEach((section, index) => {
//         const { trigger, opacity } = section;

//         gsap.to(opacity, {
//           scrollTrigger: {
//             toggleActions: "play pause resume reverse",
//             trigger: trigger,
//             start: "top 60%",
//             end: "top 0%",
//             scrub: true,
//           },
//           opacity: "0.6",
//         });
//       });

//     },
//     //end matchMedia
//   });
// });
